export default __webpack_public_path__ + "static/media/blender.1dfc3098.png";